module.exports = __webpack_public_path__ + "img/nfc.6706349a.png";